import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import SuperAdminLocationFilters from "./SuperAdminLocationFilters";

export default function SuperAdminReportsRouteShell({ children }) {
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);

  const isSuperAdminReportsRoute = location.pathname.startsWith("/superadmin/reports");
  const isReportsHome = location.pathname === "/superadmin/reports";

  const panelWrapperClassName = useMemo(() => {
    if (isReportsHome) {
      return "w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-6";
    }
    return "w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-4";
  }, [isReportsHome]);

  const handleFiltersChange = useCallback(() => {
    setRefreshKey((current) => current + 1);
  }, []);

  if (!isSuperAdminReportsRoute) {
    return children;
  }

  return (
    <>
      <div className={panelWrapperClassName}>
        <SuperAdminLocationFilters onChange={handleFiltersChange} autoApply={false} />
      </div>
      <div key={`${location.pathname}:${refreshKey}`}>{children}</div>
    </>
  );
}
